import { Text } from '@billy/design-system'

import { VERTICAL_BAR_HEIGHT } from '../../constants/verticalBarHeight'
import { VERTICAL_BAR_TICKS_WIDTH } from '../../constants/verticalBarTicksWidth'

const Y_AXIS_TICK_TOP_OFFSET = 12
const Y_AXIS_TICK_OFFSET = 2

type SalesReportYAxisTickPayload = { value?: string }

interface SalesReportYAxisTickProps {
  payload: SalesReportYAxisTickPayload
  x: number
  y: number
}

export const SalesReportYAxisTick = ({ payload, x, y }: Partial<SalesReportYAxisTickProps>) => {
  if (!payload || !x || !y) {
    return null
  }

  return (
    <foreignObject
      height={VERTICAL_BAR_HEIGHT}
      width={VERTICAL_BAR_TICKS_WIDTH - Y_AXIS_TICK_OFFSET * 2}
      x={x - VERTICAL_BAR_TICKS_WIDTH + Y_AXIS_TICK_OFFSET}
      y={y - Y_AXIS_TICK_TOP_OFFSET}
    >
      <Text title={payload.value} truncate>
        {payload.value}
      </Text>
    </foreignObject>
  )
}
